import React, {useState, useEffect, useRef} from 'react'
import {useIntl} from 'react-intl'
import Button from 'react-bootstrap/Button'
import axios, {AxiosResponse} from 'axios'
import swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import {useAuth} from '../../auth/core/Auth'
import {getCodeYear} from '../../../pages/code/list/core/_requests'

const API_URL_REAL = process.env.REACT_APP_API_URL

export function Tryos() {
  interface ApplicantData {
    tcKimlikNo: string
    ad: string
    soyad: string
    puan: number
    tmDogru: number
    syDogru: number
    tmYanlis: number
    syYanlis: number
    basariSirasi: number
    adaySayisi: number
  }

  const {logout, currentUser, setCurrentUser} = useAuth()
  const [attended, setAttended] = useState(false)
  const [checkDisabled, setCheckDisabled] = useState(false)
  const [logoutt, setLogout] = useState(false)
  const intl = useIntl()
  const [tryosNumber, setTryosNumber] = useState('')
  const [point, setPoint] = useState('')
  const [error, setError] = useState('')
  const [applicantData, setApplicantData] = useState<ApplicantData | null>(null)
  const navigate = useNavigate()
  const [file, setFile] = useState(null)
  const [fileError, setFileError] = useState('')
  const [applicatonFile, setApplicatonFile] = useState(null)
  const [applicatonFileError, setApplicatonFileError] = useState('')
  const [years, setYears]: any = useState([])
  const [selectedYear, setSelectedYear]: any = useState(undefined)
  const [generalDisabled, setGeneralDisabled] = useState(false)
  const [nextDisabled, setNextDisabled] = useState(false)
  const [trYosExamDate, setTrYosExamDate] = useState(new Date().toISOString().split('T')[0])

  const updateTryosAttended = async (newValue: string) => {
    return new Promise<void>((resolve, reject) => {
      if (currentUser?.id === undefined) {
        reject('User ID is undefined.')
        return
      }

      const updatedUser = {
        ...currentUser,
        tryosAttended: newValue,
      }

      setCurrentUser(updatedUser)
      resolve()
    })
  }

  const handleLogout = async () => {
    setLogout(true)
  }

  // const handleNotAttended2 = async () => {
  //     const response = await axios.post(`${API_URL_REAL}/Custom/UpdateTryosNotAttended`);
  //     await updateTryosAttended("0")
  //     navigate('/exam/survey');
  // }

  const handleNotAttended = async () => {
    // Kullanıcı seçimini almak için bir modal kullanıyorsanız, bu kodu modal'daki bir düğmeye veya olaya bağlayın.

    swal
      .fire({
        title:
          currentUser?.fromCyprus == '1'
            ? intl.formatMessage({
                id: 'TRYOS/GCEAL_VARMI',
              })
            : intl.formatMessage({
                id: 'TRYOS_VARMI',
              }),
        // text: intl.formatMessage({ id: 'bos' }),
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: intl.formatMessage({id: 'Yes'}),
        cancelButtonText: intl.formatMessage({id: 'No'}),
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          swal.fire({
            title: intl.formatMessage({
              id: 'Swal_proces',
            }),
            text: intl.formatMessage({id: 'Swall_wait'}),
            icon: 'info',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
          })
          setGeneralDisabled(true)
          const response = await axios.post(`${API_URL_REAL}/Custom/UpdateTryosNotAttended`)
          if (response?.status == 200) {
            await updateTryosAttended('0')
            navigate('/exam/survey')
            swal.close()
          }
        } else {
          swal.close() // Modal'ı kapatmak için bu satırı ekleyin
        }
      })
  }

  const handleNext = async () => {
    const performUpdate = async () => {
      if (!file) {
        swal.fire({
          title: intl.formatMessage({
            id: 'Error',
          }),
          text: intl.formatMessage({id: 'Please upload your exam result document.'}),
          icon: 'error',
          confirmButtonText: intl.formatMessage({id: 'Okay'}),
        })
        return
      }
      if (!applicatonFile) {
        swal.fire({
          title: intl.formatMessage({
            id: 'Error',
          }),
          text: intl.formatMessage({id: 'Please upload your exam application document.'}),
          icon: 'error',
          confirmButtonText: intl.formatMessage({id: 'Okay'}),
        })
        return
      }
      setNextDisabled(true)
      swal.fire({
        title: intl.formatMessage({
          id: 'Swal_proces',
        }),
        text: intl.formatMessage({id: 'Swall_wait'}),
        icon: 'info',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
      const formData = new FormData()
      formData.append('file', file)
      formData.append('applicationFile', applicatonFile)
      const response = await axios.post(`${API_URL_REAL}/Custom/UpdateUserFromTrYos`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      if (response?.status == 200) {
        swal.close()
        swal
          .fire({
            title: intl.formatMessage({
              id: 'Success',
            }),
            text: intl.formatMessage({id: 'Swal_Basarili'}),
            icon: 'success',
            confirmButtonText: intl.formatMessage({id: 'Okay'}),
          })
          .then((result) => {
            if (result.isConfirmed) {
            }
          })
        await updateTryosAttended('1')
        navigate('/exam/survey')
      } else {
        swal.close()
        swal.fire({
          title: intl.formatMessage({
            id: 'Error',
          }),
          text: intl.formatMessage({id: 'Error_Massage'}),
          icon: 'error',
          confirmButtonText: intl.formatMessage({id: 'Okay'}),
        })
        setNextDisabled(false)
      }
    }
    performUpdate()
  }

  const handleFileChange = (e: any) => {
    const selected = e.target.files[0]
    const ALLOWED_TYPES = ['application/pdf']

    if (selected && ALLOWED_TYPES.includes(selected.type)) {
      setFile(selected)
      setFileError('')
    } else {
      setFile(null)
      setFileError(intl.formatMessage({id: 'Please select a valid file type (.pdf)'}))
    }
  }

  const handleApplicationFileChange = (e: any) => {
    const selected = e.target.files[0]
    const ALLOWED_TYPES = ['application/pdf']

    if (selected && ALLOWED_TYPES.includes(selected.type)) {
      setApplicatonFile(selected)
      setApplicatonFileError('')
    } else {
      setApplicatonFile(null)
      setApplicatonFileError(intl.formatMessage({id: 'Please select a valid file type (.pdf)'}))
    }
  }

  useEffect(() => {
    getCodeYear().then((res: any) => {
      setYears(res)
    })
  }, [])

  useEffect(() => {
    if (logoutt) {
      logout()
    } else {
      if (currentUser?.tryosAttended === '0' || currentUser?.tryosAttended === '1')
        navigate('/exam/survey')
    }
  }, [logoutt])

  const handleCheck = async () => {
    swal.fire({
      title: intl.formatMessage({
        id: 'Swal_proces',
      }),
      text: intl.formatMessage({id: 'Swall_wait'}),
      icon: 'info',
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    })
    setCheckDisabled(true)

    try {
      try {
        const response = await axios.post(
          `${API_URL_REAL}/Custom/CheckTrYosPoints?TCKIMLIKNO=${tryosNumber}&PUANIN=${point}&year=${selectedYear}&examdate=${trYosExamDate}`
        )
        setApplicantData(response.data)
        swal.close()
      } catch (error: any) {
        setApplicantData(null)
        if (error.response && error.response.data && error.response.data.message) {
          swal.close()
          const errorMessage = error.response.data.message
          swal.fire({
            title: intl.formatMessage({id: 'Error'}),
            text: intl.formatMessage({id: errorMessage}),
            icon: 'error',
            confirmButtonText: intl.formatMessage({id: 'Okay'}),
          })
        } else {
          swal.close()
          swal.fire({
            title: intl.formatMessage({id: 'Error'}),
            text: intl.formatMessage({
              id: 'The information you have provided is invalid. Please check and try again.',
            }),
            icon: 'error',
            confirmButtonText: intl.formatMessage({id: 'Okay'}),
          })
        }
      }
    } catch (error) {
      swal.close()
      //console.error('There was an error!', error);
    }
    setCheckDisabled(false)
  }

  const goToExamGceal = () => {
    swal
      .fire({
        icon: 'warning',
        title: intl.formatMessage({id: 'Swal_onay'}),
        text: intl.formatMessage({id: 'GCEAL_Uyari_4'}),
        showCancelButton: true,
        confirmButtonText: intl.formatMessage({id: 'Yes'}),
        cancelButtonText: intl.formatMessage({id: 'No'}),
      })
      .then((result) => {
        if (result.isConfirmed) {
          navigate('/exam/gceal')
        }
      })
  }

  const setAttendedTrue = () => {
    if (!!currentUser && currentUser?.fromCyprus == '1') {
      swal
        .fire({
          icon: 'warning',
          title: intl.formatMessage({id: 'Swal_onay'}),
          text: intl.formatMessage({id: 'TRYOS_Uyari_1'}),
          showCancelButton: true,
          confirmButtonText: intl.formatMessage({id: 'Yes'}),
          cancelButtonText: intl.formatMessage({id: 'No'}),
        })
        .then((result) => {
          if (result.isConfirmed) {
            setAttended(true)
          }
        })
    } else {
      setAttended(true)
    }
  }
  return (
    <>
      {!applicantData && !attended && (
        <div className='row g-5 g-xxl-8 justify-content-center text-center'>
          <div className='col-12'>
            <Button disabled={generalDisabled} variant='primary' onClick={() => setAttendedTrue()}>
              {intl.formatMessage({id: 'I have TR-YÖS exam result'})}
            </Button>
          </div>
          {!!currentUser && currentUser?.fromCyprus == '1' ? (
            <div className='col-12'>
              <a onClick={goToExamGceal}>
                <Button disabled={generalDisabled} variant='primary'>
                  {intl.formatMessage({id: 'I have GCEAL exam result'})}
                </Button>
              </a>
            </div>
          ) : (
            <></>
          )}
          <div className='col-12'>
            <Button
              disabled={generalDisabled}
              variant='secondary'
              onClick={() => handleNotAttended()}
            >
              {!!currentUser && currentUser?.fromCyprus == '1'
                ? intl.formatMessage({id: "I don't have TR-YÖS/GCEAL exam result"})
                : intl.formatMessage({id: "I don't have TR-YÖS exam result"})}
            </Button>
          </div>
        </div>
      )}

      {attended && !applicantData && (
        <>
          <div className='row fv-row mt-7'>
            <div className='col-xl-12'>
              <div className='fv-row mb-5'>
                <label className='form-label fw-bolder text-dark fs-6'>
                  {intl.formatMessage({id: 'Exam_Year'})}
                </label>
                <select
                  className='form-select form-select-solid form-select-md'
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                >
                  <option value=''>{intl.formatMessage({id: 'SEÇİNİZ'})}</option>
                  {years.map((myval: any) => (
                    <option value={myval} key={myval as any}>
                      {myval as any}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div className='row fv-row '>
            <div className='col-xl-12'>
              <div className='fv-row mb-5'>
                <label className='form-label fw-bolder text-dark fs-6'>
                  {intl.formatMessage({id: 'TR-YÖS Exam Date'})}
                </label>
                <input
                  type='date'
                  value={trYosExamDate}
                  onChange={(e) => setTrYosExamDate(e.target.value)}
                  className='form-control form-control-lg form-control-solid'
                />
              </div>
            </div>
          </div>
          <div className='row fv-row '>
            <div className='col-xl-12'>
              <div className='fv-row mb-5'>
                <label className='form-label fw-bolder text-dark fs-6'>
                  {intl.formatMessage({id: 'TR-YÖS participate number'})}
                </label>
                <input
                  placeholder={intl.formatMessage({id: 'TR-YÖS participate number'})}
                  type='text'
                  value={tryosNumber}
                  onChange={(e) => setTryosNumber(e.target.value)}
                  className='form-control form-control-lg form-control-solid'
                />
              </div>
            </div>
          </div>
          <div className='row fv-row'>
            <div className='col-xl-12'>
              <div className='fv-row mb-5'>
                <label className='form-label fw-bolder text-dark fs-6'>
                  {intl.formatMessage({id: 'Exam Score for TR-YÖS'})}
                </label>
                {/* <input
                                        placeholder={intl.formatMessage({ id: 'Exam Score' })}
                                        type="text"
                                        value={point}
                                        onKeyDown={(e: any) => {
                                            if (e.key === '.' && e.target.value.indexOf(',') === -1) { // Nokta tuşuna basıldığında ve virgül yoksa
                                                e.preventDefault(); // Noktanın varsayılan davranışını engelle
                                                const cursorPosition = e.target.selectionStart; // İmlecin konumunu al
                                                e.target.value = e.target.value.substring(0, cursorPosition) + ',' + e.target.value.substring(cursorPosition); // Noktayı imlecin bulunduğu konuma virgül olarak ekle
                                                e.target.setSelectionRange(cursorPosition + 1, cursorPosition + 1); // İmleci virgülün sağ tarafına konumlandır
                                            } else if (e.key === ',' && e.target.value.split(',').length > 1) { // Virgül tuşuna basıldığında ve virgül zaten varsa
                                                e.preventDefault(); // Virgülün varsayılan davranışını engelle
                                            }
                                        }}
                                        onInput={(e: any) => {
                                            e.target.value = e.target.value.replace(/[^0-9,]/g, ''); // Sadece rakamlar ve virgül kabul edilir
                                        }}
                                        onChange={(e) => setPoint(e.target.value)}
                                        className='form-control form-control-lg form-control-solid'
                                    /> */}

                <input
                  placeholder={intl.formatMessage({id: 'Exam Score'})}
                  type='text'
                  value={point}
                  onKeyDown={(e: any) => {
                    if (e.key === '.' || (e.key === ',' && e.target.value.includes(','))) {
                      e.preventDefault() // Nokta ve tekrar virgül girilmesini engelle
                    }
                  }}
                  onInput={(e: any) => {
                    e.target.value = e.target.value.replace(/[^0-9,]/g, '') // Sadece rakamlar ve virgül kabul edilir
                  }}
                  onChange={(e) => setPoint(e.target.value)}
                  className='form-control form-control-lg form-control-solid'
                />
              </div>
            </div>
          </div>
        </>
      )}
      {applicantData && (
        <>
          <h2>{intl.formatMessage({id: 'TR-YÖS Applicant Information'})}</h2>
          <div className='row mt-7'>
            <div className='col-12'>
              <p>
                <strong>{intl.formatMessage({id: 'Applicant No'})}:</strong>{' '}
                {applicantData.tcKimlikNo}
              </p>
              <p>
                <strong>{intl.formatMessage({id: 'Name'})}:</strong> {applicantData.ad}
              </p>
              <p>
                <strong>{intl.formatMessage({id: 'Surname'})}:</strong> {applicantData.soyad}
              </p>
              <p>
                <strong>{intl.formatMessage({id: 'Exam Score'})}:</strong> {applicantData.puan}
              </p>
            </div>
          </div>
          <div className='row mt-7'>
            <div className='col-12'>
              <p>
                <strong>
                  {intl.formatMessage({id: 'Upload your exam result document'})} (PDF):
                </strong>
              </p>
              <input type='file' onChange={handleFileChange} accept='.pdf' />
              {fileError && <p style={{color: 'red'}}>{fileError}</p>}
            </div>
          </div>
          <div className='row mt-7'>
            <div className='col-12'>
              <p>
                <strong>
                  {intl.formatMessage({id: 'Upload your exam application document'})} (PDF):
                </strong>
              </p>
              <input type='file' onChange={handleApplicationFileChange} accept='.pdf' />
              {applicatonFileError && <p style={{color: 'red'}}>{applicatonFileError}</p>}
            </div>
          </div>
        </>
      )}

      {attended && !applicantData && (
        <div className='row fv-row mt-7 justify-content-end'>
          <div className='col-xl-6 d-flex justify-content-end'>
            <Button variant='warning' disabled={checkDisabled} onClick={handleCheck}>
              {intl.formatMessage({id: 'Check'}) + ' > '}
            </Button>
          </div>
        </div>
      )}

      {applicantData && (
        <div className='row fv-row mt-7 justify-content-end'>
          <div className='col-xl-6 d-flex justify-content-end'>
            <Button variant='success' disabled={nextDisabled} onClick={handleNext}>
              {intl.formatMessage({id: 'Next'}) + ' > '}
            </Button>
          </div>
        </div>
      )}

      <div className='row fv-row mt-7 justify-content-end'>
        <div className='col-xl-6 d-flex justify-content-end'>
          <Button disabled={generalDisabled} variant='danger' onClick={handleLogout}>
            {intl.formatMessage({id: 'Logout'})}
          </Button>
        </div>
      </div>
    </>
  )
}
